/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SetSlackDirectoryDefaultProjectRequestBody,
  SetSlackDirectoryDefaultProjectRequestBody$Outbound,
  SetSlackDirectoryDefaultProjectRequestBody$outboundSchema,
} from "../components/setslackdirectorydefaultprojectrequestbody.js";

export type SetSlackDirectoryDefaultProjectSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type SetSlackDirectoryDefaultProjectRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  setSlackDirectoryDefaultProjectRequestBody:
    SetSlackDirectoryDefaultProjectRequestBody;
};

/** @internal */
export type SetSlackDirectoryDefaultProjectSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const SetSlackDirectoryDefaultProjectSecurity$outboundSchema:
  z.ZodMiniType<
    SetSlackDirectoryDefaultProjectSecurity$Outbound,
    SetSlackDirectoryDefaultProjectSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function setSlackDirectoryDefaultProjectSecurityToJSON(
  setSlackDirectoryDefaultProjectSecurity:
    SetSlackDirectoryDefaultProjectSecurity,
): string {
  return JSON.stringify(
    SetSlackDirectoryDefaultProjectSecurity$outboundSchema.parse(
      setSlackDirectoryDefaultProjectSecurity,
    ),
  );
}

/** @internal */
export type SetSlackDirectoryDefaultProjectRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  SetSlackDirectoryDefaultProjectRequestBody:
    SetSlackDirectoryDefaultProjectRequestBody$Outbound;
};

/** @internal */
export const SetSlackDirectoryDefaultProjectRequest$outboundSchema:
  z.ZodMiniType<
    SetSlackDirectoryDefaultProjectRequest$Outbound,
    SetSlackDirectoryDefaultProjectRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      setSlackDirectoryDefaultProjectRequestBody:
        SetSlackDirectoryDefaultProjectRequestBody$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        setSlackDirectoryDefaultProjectRequestBody:
          "SetSlackDirectoryDefaultProjectRequestBody",
      });
    }),
  );

export function setSlackDirectoryDefaultProjectRequestToJSON(
  setSlackDirectoryDefaultProjectRequest:
    SetSlackDirectoryDefaultProjectRequest,
): string {
  return JSON.stringify(
    SetSlackDirectoryDefaultProjectRequest$outboundSchema.parse(
      setSlackDirectoryDefaultProjectRequest,
    ),
  );
}
